import axios from 'axios';
import { Env, ENV_VARS } from './config';

interface RawTokenReponse {
  access_token: string;
  expires_in: 3600;
  id_token: string;
  token_type: string;
}

interface TokenResponse {
  accessToken: string;
  expiresIn: number;
  idToken: string;
  tokenType: string;
}

export const createAuthClient = (env: Env) => {
  const { CLIENT_ID, AUTH_HOST: HOST } = ENV_VARS[env];
  return {
    refreshAccessToken: async (refreshToken: string): Promise<TokenResponse> => {
      const requestData = [
        {
          key: 'refresh_token',
          value: refreshToken,
        },
        {
          key: 'grant_type',
          value: 'refresh_token',
        },
        {
          key: 'client_id',
          value: CLIENT_ID,
        },
      ];

      const formBody = requestData.map(
        (requestPart) =>
          encodeURIComponent(requestPart.key) + '=' + encodeURIComponent(requestPart.value)
      );

      const body = formBody.join('&');

      const response = await axios.post<RawTokenReponse>(HOST + '/oauth2/token', body, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });

      const tokenData = response.data;

      return {
        accessToken: tokenData.access_token,
        expiresIn: tokenData.expires_in,
        idToken: tokenData.id_token,
        tokenType: tokenData.token_type,
      };
    },
  };
};
